'use client';

import { useRouter } from '@/navigation';
import ArrowRight from '../../_icons/Arrow-right';
import { Button } from '../Button';

export function CallToAction({
	title,
	description,
	buttonText,
	buttonIcon,
	href,
}: {
	title: string;
	description: string;
	buttonText: string;
	buttonIcon?: string;
	href: string;
}) {
	const router = useRouter();
	return (
		<div className="bg-gold-light/10 flex flex-col justify-center overflow-hidden rounded-4xl px-32 py-10 max-md:px-5 lg:py-20">
			<div className="flex w-full flex-col items-center text-center text-black max-md:max-w-full">
				<h1 className="text-xl leading-10 font-bold max-md:max-w-full">{title}</h1>
				<p className="mt-4 mb-10 text-base leading-8 max-md:max-w-full">{description}</p>
				<Button
					intent="secondary"
					onClick={() => {
						// @ts-expect-error nono
						router.push(href);
					}}
				>
					{buttonText}
					<ArrowRight />
				</Button>
			</div>
		</div>
	);
}
